
export const FOOTER_TEXT = {
    ALL_RIGHTS: 'All rights reserved',
    CLICK_HERE: 'click here to',
    CONTACT_US : 'contact us',
    EMAIL: 'Email address: ',
    HELPLINE: 'Helpline: ',
    CONTACT_US_UPPERCASE: 'Contact us'
}

export const helpLineVaraibles =
  [
    {
      title: "General helpline",
      emailAddress: "events@infinitheism.com",
      helplineNumber: "+91-9841660000 ",
      timings: "(9:30 a.m. - 6:00 p.m. IST)"
    },
    {
      title: "HDB/MSD helpline",
      emailAddress: "hdb@infinitheism.com",
      helplineNumber: "+91-9841670000",
    }
  ]